import { appRoutes } from "./AppRoutesConfig";

// Registered site sections, using the same labels as their navigation/pages.
export const siteSearchPages = [
  { url: appRoutes.about, titleKey: "view.about.aboutDSU.button" },
  { url: appRoutes.dsuNumbers, titleKey: "components.header.dsuNumbers" },
  { url: appRoutes.news, titleKey: "components.header.news" },
  { url: appRoutes.legislation, titleKey: "components.header.legislation" },
  { url: appRoutes.dialog, titleKey: "components.header.dialog" },
  { url: appRoutes.contact, titleKey: "components.header.contact" },
  { url: appRoutes.map, titleKey: "components.header.map" },
  { url: appRoutes.officials, titleKey: "view.newsAndMedia.communications" },
  { url: appRoutes.newsAndPartners, titleKey: "view.newsAndMedia.ParnersNews" },
  { url: appRoutes.events, titleKey: "components.ipCategories.events" },
  { url: appRoutes.projects, titleKey: "view.projects.title" },
  { url: appRoutes.partners, titleKey: "view.partners.title" },
  { url: appRoutes.institutionsContact, titleKey: "view.about.contactInstitutions.title" },
  { url: appRoutes.legislationOrders, titleKey: "view.legislationOrders.title" },
  { url: appRoutes.legislationDecisions, titleKey: "view.cnsuDecisions.title" },
  { url: appRoutes.legislationConsults, titleKey: "view.consultations.title" },
  { url: appRoutes.legislationEvents, titleKey: "view.legislationEvents.title" },
];
